<div class="alert alert-{{ color }} {{ type }} {{ dismissible }} fade show">
  <button
    *ngIf="closeButton"
    type="button"
    class="btn-close"
    data-bs-dismiss="alert"
    aria-label="btn-close"
  ></button>
  <div class="body">{{ text }}</div>
  <ng-content select="[bodyContent]"></ng-content>
</div>
